module.exports = __webpack_public_path__ + "static/media/haskell.d674092d.png";